import axios from 'axios';

const instance = axios.create({
       baseURL:"/API/"
      //baseURL:"https://edit.mazaraat.org/API/"
      // baseURL:'https://localhost:44338/'
     //baseURL:'http://192.168.8.1/API/'
});

export default instance;